import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "./home/home.component";
import { PublishedNoteComponent } from "./published-note/published-note.component";
import { NoteEditorComponent } from "./note-editor/note-editor.component";

const routes: Routes = [
    { path: "", component: HomeComponent },
    {
        path: "note/:id",
        component: NoteEditorComponent,
    },
    {
        path: "published/:id",
        component: PublishedNoteComponent,
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
